import { TimePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import { Dayjs } from 'dayjs';
import React, { FC, useEffect, useRef } from 'react';

const { RangePicker } = TimePicker;

const TimeRangePickerWithDots: FC<RangePickerProps> = props => {
  const divElem = useRef(null);
  const inputElem = useRef<[HTMLInputElement | null, HTMLInputElement | null]>([null, null]);
  const prevDataValue = useRef<[string, string]>(['', '']);

  const onFirstInputChange = ({ target }: any) => {
    if (prevDataValue.current[0].length > target.value.length) {
      prevDataValue.current[0] = target.value;
      return;
    }

    if (target.value.length === 2) {
      target.value += ':';
    }

    if (target.value.length > 5) {
      target.value = target.value.substring(0, 5);
    }
    prevDataValue.current[0] = target.value;
  };

  const onSecondInputChange = ({ target }: any) => {
    if (prevDataValue.current[1].length > target.value.length) {
      prevDataValue.current[1] = target.value;
      return;
    }

    if (target.value.length === 2) {
      target.value += ':';
    }

    if (target.value.length > 5) {
      target.value = target.value.substring(0, 5);
    }
    prevDataValue.current[1] = target.value;
  };

  useEffect(() => {
    return () => {
      inputElem?.current[0]?.removeEventListener('input', onFirstInputChange);
      inputElem?.current[1]?.removeEventListener('input', onSecondInputChange);
    };
  }, []);

  const onDateChange = (date: [start: Dayjs | null, end: Dayjs | null] | null, dateString: [string, string]) => {
    if (inputElem?.current && dateString[0] === '') {
      prevDataValue.current = dateString;
    }
    props?.onChange?.(date, dateString);
  };

  return (
    <RangePicker
      {...props}
      ref={divElem}
      onChange={onDateChange}
      onFocus={(e: React.FocusEvent<HTMLElement>, info: any) => {
        if (!inputElem.current[0]) {
          const firstElem: HTMLInputElement | null =
            (divElem?.current as any)?.nativeElement?.children[0]?.children[0] || null;
          inputElem.current[0] = firstElem;
          inputElem.current[0]?.addEventListener('input', onFirstInputChange);
        }
        if (!inputElem.current[1]) {
          const secondElem: HTMLInputElement | null =
            (divElem?.current as any)?.nativeElement?.children[2]?.children[0] || null;
          inputElem.current[1] = secondElem;
          inputElem.current[1]?.addEventListener('input', onSecondInputChange);
        }
        props?.onFocus?.(e, info);
      }}
    />
  );
};

export default TimeRangePickerWithDots;
